import { head } from 'ramda';
import { jackpotWinsStates } from '@namespace/bonuses';
import { getGamesByLaunchIds, getJackpotWins } from '../hooks/api';
import { JackpotsType, JackpotWin } from '../types';
import { getInHouseJackpotsOrder } from '../utils';
import {
  calcTotalInHouseJackpot,
  formatInHouseJackpotWinnersGames,
  formatJackpots
} from './normalize';
import { IInHouseJackpotsState, useInHouseJackpotsStore } from './store';

interface ActionsCreatorParams {
  setState: (
    callback:
      | ((state: IInHouseJackpotsState) => Partial<IInHouseJackpotsState>)
      | Partial<IInHouseJackpotsState>
  ) => void;
}

export const actionsCreator = ({ setState }: ActionsCreatorParams) => ({
  FETCH_IN_HOUSE_JACKPOT_WINNERS_GAMES: async (launchIds: string[]) => {
    try {
      const data = await getGamesByLaunchIds(launchIds);

      setState((state) => ({
        games: {
          ...state.games,
          ...formatInHouseJackpotWinnersGames(data)
        }
      }));
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      }
    }
  },

  SET_IN_HOUSE_JACKPOT_WIN: (jackpotWin: JackpotWin) => {
    setState({ jackpotWin });
  },

  FETCH_IN_HOUSE_JACKPOT_WINS: async () => {
    try {
      const { status, data } = await getJackpotWins({
        status: [jackpotWinsStates.AVAILABLE]
      });

      if (status === 'success' && data.length > 0) {
        const [lastWonJackpot] = data;

        setState({
          jackpotWin: { ...lastWonJackpot, jackpotId: lastWonJackpot.id }
        });
      }
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      }
    }
  },

  SET_IN_HOUSE_JACKPOTS: (jackpots: JackpotsType, userCurrency: string) => {
    const formattedJackpots = formatJackpots(jackpots, userCurrency);

    setState({
      jackpots: formattedJackpots,
      ids: getInHouseJackpotsOrder(jackpots),
      totalJackpot: calcTotalInHouseJackpot(formattedJackpots),
      currency: head(Object.values(formattedJackpots))?.convertedCurrency
    });
  }
});

export const inHouseJackpotsActions = actionsCreator(useInHouseJackpotsStore);
